module.exports = "/images/sm-calendar-placeholder.svg?dd1723c21d239cf8cf7c39d172f247b0";